
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls the window to the top
 * whenever the pathname in the URL changes, unless prevented by location state.
 * 
 * This component should be placed inside the Router but outside the Routes component.
 */
const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // Ellenőrizzük, hogy a preventScroll megakadályozza-e a görgetést
    if (state && state.preventScroll === true) {
      // Ha preventScroll === true, akkor NE görgessünk
      return;
    }
    
    // Egyébként görgessünk az oldal tetejére
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname, state]);

  return null;
};

export default ScrollToTop;
